module.exports = __webpack_public_path__ + "img/search-icon.b6d5fc6c.svg";